import React from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import './InsightDetail.css';
import { insights } from '../data/site';

const InsightDetail = () => {
  const { id } = useParams();
  const article = insights.find((i) => i.id === id);

  if (!article) return <Navigate to="/insights" replace />;

  const related = insights.filter((i) => i.id !== id).slice(0, 3);

  return (
    <div className="insight-detail-page page-shell">
      <section className="ind-hero section-dark">
        <div className="site-container ind-hero-inner">
          <Link to="/insights" className="ind-back">← All insights</Link>
          <span className="eyebrow-tag" >{article.category}</span>
          <h1>{article.title}</h1>
          <div className="ind-meta">
            <span>{article.author} · {article.role}</span>
            <span>•</span>
            <span>{article.date}</span>
            <span>•</span>
            <span>{article.readTime}</span>
          </div>
        </div>
      </section>

      <section className="ind-cover">
        <div className="site-container">
          <img src={article.image} alt={article.title} />
        </div>
      </section>

      <section className="section ind-body-section">
        <div className="site-container ind-body">
          <p className="ind-lede">{article.excerpt}</p>
          {article.body.map((para, idx) => (<p key={idx}>{para}</p>))}

          <div className="ind-tags">
            {(article.tags || []).map((tag) => (<span key={tag}>{tag}</span>))}
          </div>

          <div className="ind-author-card">
            <div className="ind-author-avatar"><span>{article.author.split(' ').map((n) => n[0]).slice(0, 2).join('')}</span></div>
            <div>
              <strong>{article.author}</strong>
              <span>{article.role}</span>
            </div>
          </div>
        </div>
      </section>

      <section className="section ind-related section-dark">
        <div className="site-container-wide">
          <span className="section-eyebrow">More from Dalytix</span>
          <h2 className="section-title">Related insights.</h2>
          <div className="ind-related-grid">
            {related.map((r) => (
              <Link to={`/insights/${r.id}`} className="ind-related-card glass-card" key={r.id}>
                <img src={r.image} alt={r.title} />
                <div className="ind-related-body">
                  <span className="eyebrow-tag" >{r.category}</span>
                  <h3>{r.title}</h3>
                  <span>{r.readTime}</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default InsightDetail;
